// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"019e073a","592":"478a79a1"}[chunkId] + ".chunk.js";
};